import { MapPin, Monitor, CalendarDays, Clock, CreditCard } from "lucide-react";
import { useReveal } from "../../hooks/useReveal";

const ITEMS = [
  {
    icon: MapPin,
    label: "In-Person",
    value: "Nottingham City Centre",
    testid: "practical-location-card",
  },
  {
    icon: Monitor,
    label: "Online · UK-wide",
    value: "Sessions over Zoom",
    testid: "practical-online-card",
  },
  {
    icon: CalendarDays,
    label: "Availability",
    value: "Evenings & weekends",
    testid: "practical-availability-card",
  },
  {
    icon: CreditCard,
    label: "Standard Fee",
    value: "£145 · 50-min session",
    note: "Typical frequency: bi-weekly or weekly",
    testid: "practical-fee-50-card",
  },
  {
    icon: Clock,
    label: "Extended Fee",
    value: "£261 · 90-min session",
    note: "Typical frequency: bi-weekly or weekly",
    testid: "practical-fee-90-card",
  },
];

const INSURERS = ["AXA", "AVIVA", "BUPA", "WPA", "VITALITY"];

export const Practicalities = () => {
  const ref = useReveal();
  return (
    <section
      id="practicalities"
      data-testid="practicalities-section"
      className="bg-[#FDFBF7]"
    >
      <div className="mx-auto max-w-[1320px] px-6 md:px-10 lg:px-16 py-20 md:py-20 lg:py-24">
        <div ref={ref} className="reveal">
          <div className="max-w-3xl mb-12 md:mb-16">
            <p className="eyebrow-rule text-[11px] uppercase tracking-[0.28em] text-[#4A4D4A] mb-5">
              <span>04 · Practicalities &amp; Fees</span>
            </p>
            <h2 className="font-serif-display text-3xl md:text-4xl lg:text-[3rem] leading-[1.1] tracking-[-0.02em] text-[#1A1C1A] font-medium">
              The essentials, at a{" "}
              <em className="italic font-normal text-[#1B2E26]">glance</em>.
            </h2>
          </div>

          {/* 5 visual cards */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 border-t border-l border-[#DCD7CE]">
            {ITEMS.map((it) => {
              const Icon = it.icon;
              return (
                <div
                  key={it.label}
                  data-testid={it.testid}
                  className="p-6 md:p-8 border-r border-b border-[#DCD7CE] bg-[#FDFBF7] hover:bg-[#F3F0EA] transition-colors duration-300"
                >
                  <Icon
                    size={20}
                    strokeWidth={1.4}
                    className="text-[#1B2E26]"
                  />
                  <p className="mt-5 text-[10px] uppercase tracking-[0.24em] text-[#4A4D4A]">
                    {it.label}
                  </p>
                  <p className="mt-2 font-serif-display text-xl md:text-2xl text-[#1A1C1A] leading-snug">
                    {it.value}
                  </p>
                  {it.note && (
                    <p className="mt-3 text-xs text-[#4A4D4A] leading-relaxed">
                      {it.note}
                    </p>
                  )}
                </div>
              );
            })}
          </div>

          {/* Insurance wordmarks — single source */}
          <div
            data-testid="insurance-wordmarks"
            className="mt-16 md:mt-20 border-t border-b border-[#DCD7CE] py-10 md:py-12"
          >
            <p className="text-[10px] uppercase tracking-[0.28em] text-[#4A4D4A] text-center mb-8">
              Approved Insurance Provider
            </p>
            <div className="flex flex-wrap items-center justify-center gap-x-14 gap-y-6">
              {INSURERS.map((name) => (
                <span
                  key={name}
                  className="font-serif-display text-2xl md:text-3xl tracking-[0.18em] text-[#4A4D4A] hover:text-[#1B2E26] transition-colors"
                >
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
